import config from '../config';
import { handleResponse } from "./builder";

export const register = user => fetch(`${config.apiUrl}/register?disableEmailValidation=1`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(user)
})
    .then(handleResponse)

export const me = userId => fetch(`${config.apiUrl}/me`, { headers: { Authorization: `Bearer ${userId}` } })
    .then(handleResponse)

export const login = (username, password) => fetch(`${config.apiUrl}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
})
    .then(handleResponse)

export const update = user => fetch(`${config.apiUrl}/me`, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.id}`
    },
    body: JSON.stringify(user)
})
    .then(handleResponse)

export const forgotPassword = (email, lang) => fetch(`${config.apiUrl}/forgot-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email, actionId: config.actions.forgotPassword[lang] })
})
    .then(handleResponse)

export const unsubscribe = (email) => fetch(`${config.apiUrl}/unsubscribe`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
})
    .then(handleResponse)

export const executeActions = userId => fetch(`${config.apiUrl}/me/action`, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userId}`
    }
})
    .then(handleResponse)

export const unsubscribeEmail = (email) => fetch(`${config.apiUrl}/unsubscribe-email`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
})
    .then(handleResponse)

export const getCharges = userId => fetch(`${config.apiUrl}/me/charge`, { headers: { Authorization: `Bearer ${userId}` } })
    .then(handleResponse)

export const getRefunds = userId => fetch(`${config.apiUrl}/me/refund`, { headers: { Authorization: `Bearer ${userId}` } })
    .then(handleResponse)

export async function getSubscription(userId) {
    const response = await fetch(`${config.apiUrl}/me/subscription`, { headers: { Authorization: `Bearer ${userId}` } })
    return handleResponse(response)
}

export async function changePassword(customerId, password, lang) {
    const actionId = config.actions.successPassword[lang] || config.actions.successPassword.en
    const response = await fetch(`${config.apiUrl}/me/password`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${customerId}`
        },
        body: JSON.stringify({ customerId, password, actionId })
    })

    return handleResponse(response)
}

export function isValidEmail(email) {
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email.toLowerCase());
}